<div class="title-container" *ngIf="title">
  <h2 class="title">{{ title }}</h2>
  <button class="icon-button info" (click)="expandInfo()">
    <svg-icon src="assets/icons/info-circle.svg"></svg-icon>
  </button>
  <button *ngIf="primaryIconUrl" class="icon-button primary" (click)="primaryIconClicked.emit()">
    <svg-icon [src]="primaryIconUrl"></svg-icon>
  </button>
</div>
<p class="info-text" *ngIf="showInfo">
  {{ infoText }}
</p>
<div class="primary-container" *ngIf="showEditableAction && !showCompactAction">
  <ng-content select="[expanded]"></ng-content>
  <div class="save-row">
    <button class="icon-button trash" (click)="trashIconClicked.emit()">
      <svg-icon src="assets/icons/trash.svg"></svg-icon>
    </button>
    <button
      class="button button-reverse button-pill button-save"
      (click)="saveClicked.emit()"
      [disabled]="saveDisabled">
      Save
    </button>
  </div>
</div>
<div class="primary-container compact" *ngIf="!showEditableAction && showCompactAction">
  <ng-content select="[compact]"></ng-content>
</div>
<div class="primary-container action-info" *ngIf="!showEditableAction && !showCompactAction && !primaryIconUrl">
  <ng-content select="[info]"></ng-content>
</div>
